import { render } from "./TheatreWatch.vue?vue&type=template&id=29955589&scoped=true"
import script from "./TheatreWatch.vue?vue&type=script&lang=js"
export * from "./TheatreWatch.vue?vue&type=script&lang=js"

import "./TheatreWatch.vue?vue&type=style&index=0&id=29955589&lang=scss&scoped=true"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29955589"]])

export default __exports__